<script lang="ts">
  import { userbaseStore, LogStore } from "../../stores/stores";
  import type { LogEntry } from "../../stores/types";
  import LogDetails from "./LogDetails.svelte";

  export let logs;

  logs.sort(function (a, b) {
    var timeA = a.createdBy.timestamp;
    var timeB = b.createdBy.timestamp;
    if (timeB < timeA) {
      return -1;
    }
    if (timeA > timeB) {
      return 1;
    }
    return 0;
  });
  console.log(logs);
</script>

<div>
  <div class="log-list">
    {#each logs as logentry}
      <div>
        <ul>
          <li>
            <LogDetails {logentry} />
          </li>
        </ul>
      </div>
    {/each}
  </div>
</div>
